const CONTENT_TYPE = 'Content-Type';
const AUTHORIZATION = 'Authorization';
const CHANNEL = 'X-Channel';
const BRAND = 'X-Brand';
const LANGUAGE = 'X-Lang';
const OPERATOR_ID = 'X-Operator-Id';

export const HTTP_HEADERS = {
  CONTENT_TYPE,
  AUTHORIZATION,
  CHANNEL,
  BRAND,
  LANGUAGE,
  OPERATOR_ID,
};

export const EVA_API_SERVICE_NAME = 'slots';
export const API_PREFIX = '/api/eva/slots';

export const API_URL = {
  BONUSES: '/bonus-system',
};

export const FEATURE_CONFIG_URL = '/feature-flags';
export const COMMON_CONFIG_URL = '/config/common';
export const ENTITIES_SORTING_CONFIG_URL = '/config/entities-sorting';

export const GEO_LOCATION_URL = '/api/geo-location';
